import styled from "styled-components";

import Dialog from "ds/Dialog";

export const DialogDescription = styled(Dialog.Description)`
  white-space: normal;
`;
